import { render, staticRenderFns } from "./unifyAvatar.vue?vue&type=template&id=006b55dc&scoped=true&"
import script from "./unifyAvatar.vue?vue&type=script&lang=js&"
export * from "./unifyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./unifyAvatar.vue?vue&type=style&index=0&id=006b55dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b55dc",
  null
  
)

export default component.exports